import React from "react";
import { connect } from "react-redux";
import ModalEditarAppointment from "./ModalEditarAppointment";
import FeriadosScheduler from "./FeriadosScheduler";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import ModalEliminarAppointment from "./ModalEliminarAppointment";

const FeriadosAdmin = (props) => (
  <React.Fragment>
    {props.isLoading && <LoadingOverlay />}
    <ModalEliminarAppointment />
    <ModalEditarAppointment />
    <FeriadosScheduler />
  </React.Fragment>
);

const mapStateToProps = (state) => ({
  isLoading: state.mantenedorFeriados.isLoading
    && !state.mantenedorFeriados.isOpenModalEditarScheduler
    && !state.mantenedorFeriados.isOpenModalEliminarAppointment,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(FeriadosAdmin);
